module.exports = __webpack_public_path__ + "img/united-kingdom.521ff917.svg";